import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type QuestionnaireFieldOption from 'garaje/models/questionnaire-field-option';
import type QuestionnaireSection from 'garaje/models/questionnaire-section';
import type { SignInFieldKind } from 'garaje/utils/enums';
import type { LocaleKey } from 'garaje/utils/locale-options';
import { createLocalizedProxy, type CustomTranslations } from 'garaje/utils/translations';
import { TrackedObject } from 'tracked-built-ins';

const TRANSLATABLE_ATTRIBUTES = ['name'] as const;
type TranslatableAttributes = (typeof TRANSLATABLE_ATTRIBUTES)[number];

export default class QuestionnaireField extends Model {
  @belongsTo('questionnaire-section', { async: false, inverse: 'questionnaireFields' })
  declare questionnaireSection: QuestionnaireSection;

  @hasMany('questionnaire-field-option', { async: false, inverse: 'questionnaireField' })
  declare questionnaireFieldOptions: QuestionnaireFieldOption[];

  @attr('deeply-tracked-object', { defaultValue: () => new TrackedObject() })
  declare customTranslations: CustomTranslations<TranslatableAttributes>;

  @attr('string') declare kind: SignInFieldKind;
  @attr('string') declare name: string;
  @attr('number') declare position: number;

  forLocale(selectedLocale: LocaleKey, defaultLocale: LocaleKey): this {
    if (selectedLocale !== defaultLocale) {
      return createLocalizedProxy(this, <string[]>(<unknown>TRANSLATABLE_ATTRIBUTES), selectedLocale);
    }
    return this;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'questionnaire-field': QuestionnaireField;
  }
}
